import { ESTADO_LABEL, ESTADO_STYLE, type Estado } from '@/lib/dispositivos';

/**
 * El estado del ciclo de vida, con un color por familia: verde instalado,
 * azul stock, ámbar cuarentena, naranja reparación, rojo perdido, gris baja.
 * Extraído porque sale en la lista, la ficha, la tarjeta de la propiedad y
 * los modales; copiado cuatro veces acabaría con cuatro tonos.
 */
export default function EstadoBadge({ estado, pequeno }: { estado: Estado; pequeno?: boolean }) {
  return (
    <span className={`badge flex-shrink-0 ${pequeno ? 'text-[10px]' : ''} ${ESTADO_STYLE[estado]}`}>
      {ESTADO_LABEL[estado]}
    </span>
  );
}
